export default __webpack_public_path__ + "static/media/flashingarc5.f5d2c631.png";